import React from 'react'
import ReactDOM from 'react-dom'
// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import * as serviceWorker from './serviceWorker'
import { store, persistor } from './redux/store'

import App from './App'

// Sentry.init({
//   dsn: "https://be83b573fa5c487986e68d64b11c0d67@o1158524.ingest.sentry.io/6241721",
//   integrations: [new BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)
/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister()
